import { render, staticRenderFns } from "./RolePage.vue?vue&type=template&id=240d1e08&"
import script from "./RolePage.vue?vue&type=script&lang=js&"
export * from "./RolePage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports